import { Play } from 'lucide-react';
import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import ResultPage from './ResultPage';


const PlayButtonContainer = styled.h2`
  margin-top: 1.5rem;
  font-weight: 600;
  color: #4a90e2;
  font-size: 3.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
  letter-spacing: 0.5px;
  display: flex;
  justify-content: center;
`;

const Divider = styled.div`
    height: 1px;
    background-color: ${({ theme }) => theme.dividerColor || '#ccc'};
    margin: 1rem 0; /* Space around the divider */
`;

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const {role } = useAuth();

  const handlePlayClick = () => {
    navigate('/playGame');
    // You can add logic here, like redirecting to another page or opening a media player
  };

  return (
    <Container>
      <Container className="d-flex justify-content-center mt-5 min-vh-60 mb-5">
        <Row className="w-100">
          <Col xs={12} className="text-center">
            {role === 'Customer' &&
              <>
                <PlayButtonContainer>
                  <Button
                    variant="primary"
                    size="lg"
                    className="play-button"
                    onClick={handlePlayClick}
                    style={{ gap: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                  >
                    <Play size={20} />
                    <span className="ml-3">Play Game</span>
                  </Button>
                </PlayButtonContainer>

                <div className="play-button-description mt-2">
                  <p>Click the play button to begin your journey</p>
                </div>
                <Divider />
              </>
            }
            <ResultPage />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default DashboardPage;
